import {AppDispatch} from "../../reducer/store";
import {getToken} from "../axiosToken";
import axios from "axios";
import {
    reducerGetConsolidatedBudgetFilters,
    reducerGetConsolidatedBudgetProjects,
    reducerSelectedProjects
} from "../../reducer/consolidatedbudget/reducers/reducerConsolidatedBudget";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetConsolidatedBudgetProjects = (limit: number, offset: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
        const {token} = await getToken();
        axios.defaults.headers.common['Authorization'] = token;

        const store = getState();
        const filter = store.consolidatedbudget.projects.projectsInputValues;

        try {
            const response = await axios.post(`${BASE_URL}/json/projects/consolidatedbudget`, {
                limit,
                page: offset,
                managers: [filter.managers],
                ...filter,
            });
            dispatch(reducerGetConsolidatedBudgetProjects({data: response.data}));
        } catch (e: any) {
            if (e.response && e.response.status === 401) {
                window.location.href = "/login";
            }
        }
    };

export const actionGetConsolidatedBudgetFilters = () => async (dispatch: AppDispatch) => {
    const {token} = await getToken();
    axios.defaults.headers.common['Authorization'] = token;
    try {
        const response = await axios.get(`${BASE_URL}/json/projects/consolidatedbudget/filters`);
        dispatch(reducerGetConsolidatedBudgetFilters(response.data));
    } catch {
        console.log('err');
    }
};

export const actionConsolidatedBudgeCreate =
    (data: any) => async (dispatch: AppDispatch) => {
        const { token } = await getToken();
        axios.defaults.headers.common["Authorization"] = token;

        try {
            await axios.post(
                `${BASE_URL}/json/projects/consolidatedbudget/create`,
                data
            );
        } catch (err) {
            dispatch(reducerSelectedProjects([]));
        }
    };